import script from "./answer.vue?vue&type=script&setup=true&lang=js"
export * from "./answer.vue?vue&type=script&setup=true&lang=js"

import "./answer.vue?vue&type=style&index=0&id=f8edda88&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8edda88"]])

export default __exports__